import { t as translate } from '../../../src/shared/i18n';

const DOMAIN = 'veyo-addon-image-cropper';

export function t(text: string): string {
  return translate(text, DOMAIN);
}
